<template>
	<div class="kun_loading64_container">
		<div class="loader"></div>
	</div>
</template>


<script>
	export default {
		name: "kun_loading64",
	}
</script>


<style scoped>
	.kun_loading64_container {
		display: flex;
		justify-content: center;
		align-items: center;

	}

	.loader {
		width: 100px;
		height: 46px;
		position: relative;
		border-bottom: 5px solid #FFF;
		border-top: 5px solid #FFF;
		box-sizing: border-box;
	}

	.loader:before, .loader:after {
		content: "";
		position: absolute;
		left: 0;
		top: -20px;
		width: 32px;
		height: 32px;
		border-radius: 50%;
		background: orange;
		border: 5px solid #FFF;
		box-sizing: border-box;
		animation: slide_391 1s infinite ease-in-out alternate;
	}

	.loader:after {
		top: 20px;
		animation-direction: alternate-reverse;
	}

	@keyframes slide_391 {
		0%, 20% {
			transform: translateX(70px)
		}

		80%, 100% {
			transform: translateX(-1px)
		}
	}
</style>
